import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Employee } from '../../types';

interface AdminState {
  pocs: Employee[];
  isLoading: boolean;
  error: string | null;
}

const initialState: AdminState = {
  pocs: [],
  isLoading: false,
  error: null,
};

const adminSlice = createSlice({
  name: 'admin',
  initialState,
  reducers: {
    setPocs: (state, action: PayloadAction<Employee[]>) => {
      state.pocs = action.payload || [];
    },
    addPoc: (state, action: PayloadAction<Employee>) => {
      state.pocs.push(action.payload);
    },
    updatePoc: (state, action: PayloadAction<{ id: string; updates: Partial<Employee> }>) => {
      const { id, updates } = action.payload;
      const index = state.pocs.findIndex((poc) => poc.id === id);
      if (index !== -1) {
        state.pocs[index] = { ...state.pocs[index], ...updates };
      }
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
  },
});

export const { setPocs, addPoc, updatePoc, setLoading, setError } = adminSlice.actions;
export default adminSlice.reducer;
